
import React from 'react'
import SidebarContent from './sidebar-content'
import { Menu } from './menu'


const StorboltSidebar = () => {
    return (
        <SidebarContent>



            <Menu />


        </SidebarContent>
    )
}

export default StorboltSidebar